import moment from "moment";
import { FunctionComponent, useEffect, useMemo, useState } from "react";
import { PrimaryButton } from "../../components/button";
import { Icon } from "../../components/icons";
import { Table } from "../../components/table";
import { TableHeaders } from "../../components/table/Head";
import { Widget } from "../../components/widget";

import { KycFile, KycTypedFile, useDocumentsEmailMutation, useDocumentsHistoryQuery } from "../../store/models/risk";
import { NullablePartial } from "../../utils/utils";
import { UsersDTO } from "../../store/users/models/dto";
import { processErrorFromPromise } from "../../store/errors/utils";
import { successNotificationFromPromise } from "../../store/notifications/utils";

type fieldNames = keyof KycTypedFile;
type RequestDTO = UsersDTO.Requests.UserDetails.T;
function useHeaders(): TableHeaders<fieldNames> {

    return useMemo(
        () => [
            // {
            //     name: "id",
            //     title: "Id",
            // },
            {
                name: "uploadedAt",
                title: "Uploaded At",
            },
            {
                name: "type",
                title: "Type",
            },

            // {
            //     name: "name",
            //     title: "Name",
            // },
            // {
            //     name: "fraudCheckId",
            //     title: "FraudCheckId",
            // },
            // {
            //     name: "fraudCheckId",
            //     title: "Actions",
            // },
            {
                name: "id",
                title: "Actions",
            },

        ],
        []
    );
}

export const PresentationalAllKycDocuments: FunctionComponent<{
    userDetails: NullablePartial<RequestDTO>;
}> = ({ userDetails }) => {
    const headers = useHeaders();
    const [dataHistory, setDataHistory] = useState<KycTypedFile[]>([]);
    const [disableButton, setDisableButton] = useState<boolean>(false);


    const { data: history } = useDocumentsHistoryQuery(
        {},
        { refetchOnMountOrArgChange: true }
    );

    const [sendDocuments] = useDocumentsEmailMutation();

    useEffect(() => {

        if (history) {
            let result: KycTypedFile[] = [];
            for (const [key, value] of Object.entries(history.documents) as any) {
                let subResult = value.map((v: KycFile) => ({ type: key, ...v }))
                result = [...result, ...subResult]
            }
            setDataHistory(result);
        }

    }, [history]);

    return (
        <Widget title="My KYC Documents History">
            {/* {JSON.stringify(history)} */}
            <Table<KycTypedFile, fieldNames, "type" | "uploadedAt" | "id">
                data={dataHistory}
                head={headers}
                renderFields={{
                    type: ({ type }) => (
                        <>{type.replace('_', ' ')}</>
                    ),
                    uploadedAt: ({ uploadedAt }) => (
                        <>{moment(uploadedAt).local().format("yyyy-MM-DD HH:mm")}</>
                    ),
                    id: ({ id }) => (
                        <>
                            <PrimaryButton fullWidth
                                disabled={disableButton}
                                onClick={() => {
                                    setDisableButton(true);
                                    sendDocuments({ recipientEmailAddress: userDetails.emailAddress!, documentIds: [id] })
                                        .unwrap()
                                        .then(
                                            successNotificationFromPromise('Document sent successfully')
                                        )
                                        .catch(processErrorFromPromise
                                        ).finally(() => {
                                            setDisableButton(false);
                                        })
                                }}>
                                <Icon type="email" />
                            </PrimaryButton>
                        </>
                    )
                }}
                unsortable={["type", "uploadedAt", 'id']}

            />

        </Widget>
    );
};
